var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoadingState)?_c('div',{key:"loadingState"},[_c('AtomLoadingSecondary')],1):_c('div',{key:"billingSalesReports"})}
var staticRenderFns = []

export { render, staticRenderFns }